<template>
  <section>
  <div class="navPrincipal" ></div>
    <h4 class="pl-5 mt-4 ml-1" id="letra-naranja">Mis Cursos</h4>

         <v-layout  column align-center justify-center v-if="cargando">
         <v-progress-circular indeterminate color="secondary" v-bind:width="2" v-bind:size="200"><img src="../../../static/Icononaranjo.png" alt="logo"  width="auto" height="100px"></v-progress-circular>
      </v-layout>

        <template v-else>
              <div align="center" class="mt-5" v-if="cursos.length==0">
                        
                <i style="font-size: 8em; color:#E0E0E0;"  class="material-icons">
                  error
                </i>
                <p>No existen Cursos inscritos.</p>
              </div> 
              <div v-else>
          <v-layout row wrap class="mx-5">
            <v-flex  class="tamaño-card mt-2" xs12 sm6 md4 lg3 xl3  v-for="curso in cursos" :key="curso.id">
              <v-card height="350px" class="sombreado " v-if="curso.cource_status == 1"  @click.native="verCurso(curso.course_code)" style="cursor:pointer;">
                <v-card-media  :src="curso.gallery.galleries_image" height="150px"></v-card-media>
                <v-card-title class="pt-1" primary-title height="200px">
                     <v-flex xs12 >
                      <p class="headline mb-0 truncatetitleCard accent--text" >{{ curso.cource_title }}</p>
                     </v-flex>
                     <v-flex xs12 >
                      <p class="text-justify truncateDescriptionCard body-1" >{{curso.cource_description}}</p>
                      </v-flex>
                    <div class="text-bold ">Categoria: {{curso.category.category_name}}</div>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
              </div>

              </template>
  </section>
</template>

<script>
import { getEnrollUserInCurseService } from '@/services/GetEnrollUserInCurse.service'
import { getUser } from '@/services/GetUser.service'
export default {
  data () {
    return {
      idEspecialidad: 0,
      cursos: [],
      usuario: {},
      cargando: true
    }
  },
  mounted () {
    let vm = this
    vm.loadCursos()
    this.loadUsuario()
  },
  methods: {
    loadCursos () {
      let vm = this
      getEnrollUserInCurseService.query().then(data => {
        vm.cursos = data.body
        vm.cargando = false
      })
    },
    verCurso (id) {
      this.$router.push({name: 'showCourse', params: {id: id}})
    },
    loadUsuario () {
      let vm = this
      getUser.query().then(data => {
        vm.usuario = data.body
      })
    }
  }
}
</script>

<style scoped>
.jumbo{
	background-color: white;
}

.text{
  color: #607d8b;
}

#letra-naranja{
  color: #EB6330;
}

  .tamaño-card{
      height: auto;
      margin-bottom: 10px;
      padding-bottom: 18px;
      padding-left: 8px;
      padding-right: 8px;  
  }

.truncatetitleCard {

 height: 65px; /* alto máximo del div( debe tener directa relación con la cantidad de líneas a mostrar) o puedes calcularlo de esta forma: $font-size*$line-height*$lines-to-show */

 margin: 0 auto;
/* font-size: 12px;
 line-height: 1.4;*/
 -webkit-line-clamp: 2; /*Cantidad de líneas que desea mostrar*/
 -webkit-box-orient: vertical;
 overflow: hidden;
 text-overflow: ellipsis;
}
.truncateDescriptionCard {
display: -webkit-box;
 height: 100px; /* alto máximo del div( debe tener directa relación con la cantidad de líneas a mostrar) o puedes calcularlo de esta forma: $font-size*$line-height*$lines-to-show */

 margin: 0 auto;
 -webkit-line-clamp: 5; /*Cantidad de líneas que desea mostrar*/
 -webkit-box-orient: vertical;
 overflow: hidden;
 text-overflow: ellipsis;
}
.navPrincipal{
  background-image: url('../../../static/imagenPrincipal1280.png'); 
  background-repeat: no-repeat;
  background-size: 100% 100%; height: 200px
}
</style>


// WEBPACK FOOTER //
// src/components/Curso/ShowCursoInscrito.vue